import { combineReducers, Reducer } from 'redux';
import entities from './entities';

const rootReducers = {
  entities,
};

/**
 * A function that will use combineReducers to merge additional reducers with the root reducer
 * @param {*} additionalReducers
 */

export const getRootReducerWith = (additionalReducers = {}): Reducer => combineReducers({
  ...rootReducers,
  ...additionalReducers,
});

export default combineReducers(rootReducers);
